import React from 'react';
import clsx from 'clsx';

export function ChatIcon(props: React.SVGProps<SVGSVGElement>) {
  const { className, ...rest } = props;
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      className={clsx('w-[24px] h-[24px] shrink-0 flex-none', className)}
      aria-hidden="true"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.84836 2.771C7.18302 2.42773 9.57113 2.25 12.0003 2.25C14.4292 2.25 16.8171 2.4277 19.1516 2.77091C21.1299 3.06177 22.5 4.79445 22.5 6.74056V12.7595C22.5 14.7056 21.1299 16.4382 19.1516 16.7291C18.0054 16.8976 16.8464 17.0262 15.6759 17.1135C15.5514 17.1228 15.4431 17.1875 15.379 17.2835L12.624 21.416C12.4849 21.6247 12.2508 21.75 12 21.75C11.7492 21.75 11.5151 21.6247 11.376 21.416L8.62092 17.2835C8.5569 17.1874 8.44853 17.1227 8.32408 17.1134C7.15358 17.0261 5.99452 16.8975 4.84836 16.729C2.87004 16.4381 1.5 14.7054 1.5 12.7593V6.74064C1.5 4.79455 2.87004 3.06188 4.84836 2.771ZM12.0003 3.75C9.64439 3.75 7.32921 3.92236 5.06657 4.25505C3.87679 4.42999 3 5.48457 3 6.74064V12.7593C3 14.0154 3.87679 15.07 5.06656 15.2449C6.17741 15.4083 7.30089 15.533 8.43563 15.6176C9.01156 15.6605 9.54344 15.9631 9.869 16.4514L12 19.6479L14.131 16.4515C14.4565 15.9631 14.9884 15.6606 15.5644 15.6176C16.6991 15.533 17.8226 15.4084 18.9334 15.2451C20.1232 15.0701 21 14.0155 21 12.7595V6.74056C21 5.48447 20.1232 4.42988 18.9334 4.25496C16.6709 3.92233 14.356 3.75 12.0003 3.75ZM6.75 8.25C6.75 7.83579 7.08579 7.5 7.5 7.5H16.5C16.9142 7.5 17.25 7.83579 17.25 8.25C17.25 8.66421 16.9142 9 16.5 9H7.5C7.08579 9 6.75 8.66421 6.75 8.25ZM6.75 11.25C6.75 10.8358 7.08579 10.5 7.5 10.5H12C12.4142 10.5 12.75 10.8358 12.75 11.25C12.75 11.6642 12.4142 12 12 12H7.5C7.08579 12 6.75 11.6642 6.75 11.25Z"
        fill="white"
      />
    </svg>
  );
}
